import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip } from '@mui/material';
import Chip from '@mui/material/Chip';
export const DisplayWithSeeMoreChip = (props) => {
    const { rows, nbRowsDisplayed, separator, prefix } = props;
    if (!rows || rows.length == 0)
        return '';
    if (rows.length == nbRowsDisplayed) {
        return (prefix || '') + rows.join(separator || ', ');
    }
    else {
        return _jsxs(Box, { display: 'flex', alignItems: 'center', children: [prefix || '', " ", rows.slice(0, nbRowsDisplayed), _jsx(Tooltip, { sx: { alignItems: 'center' }, title: _jsx("span", { style: { whiteSpace: 'pre-wrap' }, children: rows.join(separator) }), children: _jsx(Chip, { sx: { marginLeft: 0.5 }, size: 'small', label: "+" + (rows.length - nbRowsDisplayed) }) })] });
    }
};
